const listAttributes = [
  'type',
  'userId',
  'creationDatetime',
  'note',
  'lastEditDatetime',
  'priorityDatetime',
  'dueDatetime',
  'creatorName',
  'creator',
  'assigneeName',
  'assignee',
  'active',
  'billingRelated',
] as const;

const getAttributes = [...listAttributes];

const updateAttributes = [
  'note',
  'assignee',
  'assigneeName',
  'billingRelated',
  'active',
  'lastEditDatetime',
  'dueDatetime',
  'priorityDatetime',
] as const;

export const UserNoteAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
